import { render, staticRenderFns } from "./SafetySummaryReportDetails.vue?vue&type=template&id=7d6cb96e&scoped=true&"
import script from "./SafetySummaryReportDetails.vue?vue&type=script&lang=js&"
export * from "./SafetySummaryReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./SafetySummaryReportDetails.vue?vue&type=style&index=0&id=7d6cb96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cb96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6cb96e')) {
      api.createRecord('7d6cb96e', component.options)
    } else {
      api.reload('7d6cb96e', component.options)
    }
    module.hot.accept("./SafetySummaryReportDetails.vue?vue&type=template&id=7d6cb96e&scoped=true&", function () {
      api.rerender('7d6cb96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SafetySummaryReportDetails.vue"
export default component.exports